export const countries = Object.freeze({
  "GB": { cc: "GB", cn: "United Kingdom", pc: 44, cc3: "GBR" },
  "AL": { cc: "AL", cn: "Albania", pc: 355, cc3: "ALB" },
  "DZ": { cc: "DZ", cn: "Algeria", pc: 213, cc3: "DZA" },
  "AS": { cc: "AS", cn: "American Samoa", pc: 1684, cc3: "ASM" },
  "AD": { cc: "AD", cn: "Andorra", pc: 376, cc3: "AND" },
  "AO": { cc: "AO", cn: "Angola", pc: 244, cc3: "AGO" },
  "AI": { cc: "AI", cn: "Anguilla", pc: 1264, cc3: "AIA" },
  "AG": { cc: "AG", cn: "Antigua", pc: 1268, cc3: "ATG" },
  "AR": { cc: "AR", cn: "Argentina", pc: 54, cc3: "ARG" },
  "AM": { cc: "AM", cn: "Armenia", pc: 374, cc3: "ARM" },
  "AW": { cc: "AW", cn: "Aruba", pc: 297, cc3: "ABW" },
  "AU": { cc: "AU", cn: "Australia", pc: 61, cc3: "AUS" },
  "AT": { cc: "AT", cn: "Austria", pc: 43, cc3: "AUT" },
  "AZ": { cc: "AZ", cn: "Azerbaijan", pc: 994, cc3: "AZE" },
  "BS": { cc: "BS", cn: "The Bahamas", pc: 1242, cc3: "BHS" },
  "BH": { cc: "BH", cn: "Bahrain", pc: 973, cc3: "BHR" },
  "BD": { cc: "BD", cn: "Bangladesh", pc: 880, cc3: "BGD" },
  "BB": { cc: "BB", cn: "Barbados", pc: 1246, cc3: "BRB" },
  "BY": { cc: "BY", cn: "Belarus", pc: 375, cc3: "BLR" },
  "BE": { cc: "BE", cn: "Belgium", pc: 32, cc3: "BEL" },
  "BZ": { cc: "BZ", cn: "Belize", pc: 501, cc3: "BLZ" },
  "BJ": { cc: "BJ", cn: "Benin", pc: 229, cc3: "BEN" },
  "BM": { cc: "BM", cn: "Bermuda", pc: 1441, cc3: "BMU" },
  "BT": { cc: "BT", cn: "Bhutan", pc: 975, cc3: "BTN" },
  "BO": { cc: "BO", cn: "Bolivia", pc: 591, cc3: "BOL" },
  "BA": { cc: "BA", cn: "Bosnia and Herzegovina", pc: 387, cc3: "BIH" },
  "BW": { cc: "BW", cn: "Botswana", pc: 267, cc3: "BWA" },
  "BR": { cc: "BR", cn: "Brazil", pc: 55, cc3: "BRA" },
  "BN": { cc: "BN", cn: "Brunei", pc: 673, cc3: "BRN" },
  "BG": { cc: "BG", cn: "Bulgaria", pc: 359, cc3: "BGR" },
  "BF": { cc: "BF", cn: "Burkina Faso", pc: 226, cc3: "BFA" },
  "BI": { cc: "BI", cn: "Burundi", pc: 257, cc3: "BDI" },
  "CV": { cc: "CV", cn: "Cape Verde", pc: 238, cc3: "CPV" },
  "KH": { cc: "KH", cn: "Cambodia", pc: 855, cc3: "KHM" },
  "CM": { cc: "CM", cn: "Cameroon", pc: 237, cc3: "CMR" },
  "CA": { cc: "CA", cn: "Canada", pc: 1, cc3: "CAN" },
  "KY": { cc: "KY", cn: "Cayman Islands", pc: 1345, cc3: "CYM" },
  "CF": { cc: "CF", cn: "Central African Republic", pc: 236, cc3: "CAF" },
  "TD": { cc: "TD", cn: "Chad", pc: 235, cc3: "TCD" },
  "CL": { cc: "CL", cn: "Chile", pc: 56, cc3: "CHL" },
  "CN": { cc: "CN", cn: "China", pc: 86, cc3: "CHN" },
  "CO": { cc: "CO", cn: "Colombia", pc: 57, cc3: "COL" },
  "KM": { cc: "KM", cn: "Comoros", pc: 269, cc3: "COM" },
  "CG": { cc: "CG", cn: "Republic of the Congo", pc: 242, cc3: "COG" },
  "CR": { cc: "CR", cn: "Costa Rica", pc: 506, cc3: "CRI" },
  "CI": { cc: "CI", cn: "Côte d'Ivoire", pc: 225, cc3: "CIV" },
  "HR": { cc: "HR", cn: "Croatia", pc: 385, cc3: "HRV" },
  "CU": { cc: "CU", cn: "Cuba", pc: 53, cc3: "CUB" },
  "CW": { cc: "CW", cn: "Curaçao", pc: 599, cc3: "CUW" },
  "CY": { cc: "CY", cn: "Cyprus", pc: 357, cc3: "CYP" },
  "CZ": { cc: "CZ", cn: "Czech Republic", pc: 420, cc3: "CZE" },
  "DK": { cc: "DK", cn: "Denmark", pc: 45, cc3: "DNK" },
  "DJ": { cc: "DJ", cn: "Djibouti", pc: 253, cc3: "DJI" },
  "DM": { cc: "DM", cn: "Dominica", pc: 1767, cc3: "DMA" },
  "DO": { cc: "DO", cn: "Dominican Republic", pc: 1849, cc3: "DOM" },
  "EC": { cc: "EC", cn: "Ecuador", pc: 593, cc3: "ECU" },
  "EG": { cc: "EG", cn: "Egypt", pc: 20, cc3: "EGY" },
  "SV": { cc: "SV", cn: "El Salvador", pc: 503, cc3: "SLV" },
  "GQ": { cc: "GQ", cn: "Equatorial Guinea", pc: 240, cc3: "GNQ" },
  "ER": { cc: "ER", cn: "Eritrea", pc: 291, cc3: "ERI" },
  "EE": { cc: "EE", cn: "Estonia", pc: 372, cc3: "EST" },
  "ET": { cc: "ET", cn: "Ethiopia", pc: 251, cc3: "ETH" },
  "FJ": { cc: "FJ", cn: "Fiji", pc: 679, cc3: "FJI" },
  "FI": { cc: "FI", cn: "Finland", pc: 358, cc3: "FIN" },
  "FR": { cc: "FR", cn: "France", pc: 33, cc3: "FRA" },
  "GF": { cc: "GF", cn: "French Guiana", pc: 594, cc3: "GUF" },
  "PF": { cc: "PF", cn: "French Polynesia", pc: 689, cc3: "PYF" },
  "GA": { cc: "GA", cn: "Gabon", pc: 241, cc3: "GAB" },
  "GM": { cc: "GM", cn: "The Gambia", pc: 220, cc3: "GMB" },
  "GE": { cc: "GE", cn: "Georgia", pc: 995, cc3: "GEO" },
  "DE": { cc: "DE", cn: "Germany", pc: 49, cc3: "DEU" },
  "GH": { cc: "GH", cn: "Ghana", pc: 233, cc3: "GHA" },
  "GI": { cc: "GI", cn: "Gibraltar", pc: 350, cc3: "GIB" },
  "GR": { cc: "GR", cn: "Greece", pc: 30, cc3: "GRC" },
  "GL": { cc: "GL", cn: "Greenland", pc: 299, cc3: "GRL" },
  "GD": { cc: "GD", cn: "Grenada", pc: 1473, cc3: "GRD" },
  "GP": { cc: "GP", cn: "Guadeloupe", pc: 590, cc3: "GLP" },
  "GU": { cc: "GU", cn: "Guam", pc: 1671, cc3: "GUM" },
  "GT": { cc: "GT", cn: "Guatemala", pc: 502, cc3: "GTM" },
  "GN": { cc: "GN", cn: "Guinea", pc: 224, cc3: "GIN" },
  "GW": { cc: "GW", cn: "Guinea-Bissau", pc: 245, cc3: "GNB" },
  "GY": { cc: "GY", cn: "Guyana", pc: 592, cc3: "GUY" },
  "HT": { cc: "HT", cn: "Haiti", pc: 509, cc3: "HTI" },
  "HN": { cc: "HN", cn: "Honduras", pc: 504, cc3: "HND" },
  "HK": { cc: "HK", cn: "Hong Kong", pc: 852, cc3: "HKG" },
  "HU": { cc: "HU", cn: "Hungary", pc: 36, cc3: "HUN" },
  "IS": { cc: "IS", cn: "Iceland", pc: 354, cc3: "ISL" },
  "IN": { cc: "IN", cn: "India", pc: 91, cc3: "IND" },
  "ID": { cc: "ID", cn: "Indonesia", pc: 62, cc3: "IDN" },
  "IR": { cc: "IR", cn: "Iran", pc: 98, cc3: "IRN" },
  "IQ": { cc: "IQ", cn: "Iraq", pc: 964, cc3: "IRQ" },
  "IE": { cc: "IE", cn: "Ireland", pc: 353, cc3: "IRL" },
  "IM": { cc: "IM", cn: "Isle Of Man", pc: 44, cc3: "IMN" },
  "IL": { cc: "IL", cn: "Israel", pc: 972, cc3: "ISR" },
  "IT": { cc: "IT", cn: "Italy", pc: 39, cc3: "ITA" },
  "JM": { cc: "JM", cn: "Jamaica", pc: 1876, cc3: "JAM" },
  "JP": { cc: "JP", cn: "Japan", pc: 81, cc3: "JPN" },
  "JO": { cc: "JO", cn: "Jordan", pc: 962, cc3: "JOR" },
  "KZ": { cc: "KZ", cn: "Kazakhstan", pc: 7, cc3: "KAZ" },
  "KE": { cc: "KE", cn: "Kenya", pc: 254, cc3: "KEN" },
  "KI": { cc: "KI", cn: "Kiribati", pc: 686, cc3: "KIR" },
  "KP": { cc: "KP", cn: "North Korea", pc: 850, cc3: "PRK" },
  "KR": { cc: "KR", cn: "South Korea", pc: 82, cc3: "KOR" },
  "KW": { cc: "KW", cn: "Kuwait", pc: 965, cc3: "KWT" },
  "KG": { cc: "KG", cn: "Kyrgyzstan", pc: 996, cc3: "KGZ" },
  "LA": { cc: "LA", cn: "Laos", pc: 856, cc3: "LAO" },
  "LV": { cc: "LV", cn: "Latvia", pc: 371, cc3: "LVA" },
  "LB": { cc: "LB", cn: "Lebanon", pc: 961, cc3: "LBN" },
  "LS": { cc: "LS", cn: "Lesotho", pc: 266, cc3: "LSO" },
  "LR": { cc: "LR", cn: "Liberia", pc: 231, cc3: "LBR" },
  "LY": { cc: "LY", cn: "Libya", pc: 218, cc3: "LBY" },
  "LI": { cc: "LI", cn: "Liechtenstein", pc: 423, cc3: "LIE" },
  "LT": { cc: "LT", cn: "Lithuania", pc: 370, cc3: "LTU" },
  "LU": { cc: "LU", cn: "Luxembourg", pc: 352, cc3: "LUX" },
  "MO": { cc: "MO", cn: "Macau", pc: 853, cc3: "MAC" },
  "MG": { cc: "MG", cn: "Madagascar", pc: 261, cc3: "MDG" },
  "MW": { cc: "MW", cn: "Malawi", pc: 265, cc3: "MWI" },
  "MY": { cc: "MY", cn: "Malaysia", pc: 60, cc3: "MYS" },
  "MV": { cc: "MV", cn: "Maldives", pc: 960, cc3: "MDV" },
  "ML": { cc: "ML", cn: "Mali", pc: 223, cc3: "MLI" },
  "MT": { cc: "MT", cn: "Malta", pc: 356, cc3: "MLT" },
  "MH": { cc: "MH", cn: "Marshall Islands", pc: 692, cc3: "MHL" },
  "MQ": { cc: "MQ", cn: "Martinique", pc: 596, cc3: "MTQ" },
  "MR": { cc: "MR", cn: "Mauritania", pc: 222, cc3: "MRT" },
  "MU": { cc: "MU", cn: "Mauritius", pc: 230, cc3: "MUS" },
  "MX": { cc: "MX", cn: "Mexico", pc: 52, cc3: "MEX" },
  "FM": { cc: "FM", cn: "Federated States of Micronesia", pc: 691, cc3: "FSM" },
  "MD": { cc: "MD", cn: "Moldova", pc: 373, cc3: "MDA" },
  "MC": { cc: "MC", cn: "Monaco", pc: 377, cc3: "MCO" },
  "MN": { cc: "MN", cn: "Mongolia", pc: 976, cc3: "MNG" },
  "ME": { cc: "ME", cn: "Montenegro", pc: 382, cc3: "MNE" },
  "MS": { cc: "MS", cn: "Montserrat", pc: 1664, cc3: "MSR" },
  "MA": { cc: "MA", cn: "Morocco", pc: 212, cc3: "MAR" },
  "MZ": { cc: "MZ", cn: "Mozambique", pc: 258, cc3: "MOZ" },
  "MM": { cc: "MM", cn: "Myanmar", pc: 95, cc3: "MMR" },
  "NA": { cc: "NA", cn: "Namibia", pc: 264, cc3: "NAM" },
  "NR": { cc: "NR", cn: "Nauru", pc: 674, cc3: "NRU" },
  "NP": { cc: "NP", cn: "Nepal", pc: 977, cc3: "NPL" },
  "NL": { cc: "NL", cn: "Netherlands", pc: 31, cc3: "NLD" },
  "NC": { cc: "NC", cn: "New Caledonia", pc: 687, cc3: "NCL" },
  "NZ": { cc: "NZ", cn: "New Zealand", pc: 64, cc3: "NZL" },
  "NI": { cc: "NI", cn: "Nicaragua", pc: 505, cc3: "NIC" },
  "NE": { cc: "NE", cn: "Niger", pc: 227, cc3: "NER" },
  "NG": { cc: "NG", cn: "Nigeria", pc: 234, cc3: "NGA" },
  "NU": { cc: "NU", cn: "Niue", pc: 683, cc3: "NIU" },
  "NF": { cc: "NF", cn: "Norfolk Island", pc: 672, cc3: "NFK" },
  "MP": { cc: "MP", cn: "Northern Mariana Islands", pc: 1670, cc3: "MNP" },
  "NO": { cc: "NO", cn: "Norway", pc: 47, cc3: "NOR" },
  "OM": { cc: "OM", cn: "Oman", pc: 968, cc3: "OMN" },
  "PK": { cc: "PK", cn: "Pakistan", pc: 92, cc3: "PAK" },
  "PW": { cc: "PW", cn: "Palau", pc: 680, cc3: "PLW" },
  "PA": { cc: "PA", cn: "Panama", pc: 507, cc3: "PAN" },
  "PG": { cc: "PG", cn: "Papua New Guinea", pc: 675, cc3: "PNG" },
  "PY": { cc: "PY", cn: "Paraguay", pc: 595, cc3: "PRY" },
  "PE": { cc: "PE", cn: "Peru", pc: 51, cc3: "PER" },
  "PH": { cc: "PH", cn: "Philippines", pc: 63, cc3: "PHL" },
  "PL": { cc: "PL", cn: "Poland", pc: 48, cc3: "POL" },
  "PT": { cc: "PT", cn: "Portugal", pc: 351, cc3: "PRT" },
  "PR": { cc: "PR", cn: "Puerto Rico", pc: 1, cc3: "PRI" },
  "QA": { cc: "QA", cn: "Qatar", pc: 974, cc3: "QAT" },
  "RE": { cc: "RE", cn: "Réunion", pc: 262, cc3: "REU" },
  "RO": { cc: "RO", cn: "Romania", pc: 40, cc3: "ROU" },
  "RU": { cc: "RU", cn: "Russia", pc: 7, cc3: "RUS" },
  "RW": { cc: "RW", cn: "Rwanda", pc: 250, cc3: "RWA" },
  "BL": { cc: "BL", cn: "Saint Barthélemy", pc: 590, cc3: "BLM" },
  "SH": { cc: "SH", cn: "Saint Helena", pc: 290, cc3: "SHN" },
  "KN": { cc: "KN", cn: "Saint Kitts and Nevis", pc: 1869, cc3: "KNA" },
  "LC": { cc: "LC", cn: "Saint Lucia", pc: 1758, cc3: "LCA" },
  "MF": { cc: "MF", cn: "Saint Martin", pc: 590, cc3: "MAF" },
  "PM": { cc: "PM", cn: "Saint Pierre and Miquelon", pc: 508, cc3: "SPM" },
  "VC": { cc: "VC", cn: "Saint Vincent and the Grenadines", pc: 1784, cc3: "VCT" },
  "WS": { cc: "WS", cn: "Samoa", pc: 685, cc3: "WSM" },
  "SM": { cc: "SM", cn: "San Marino", pc: 378, cc3: "SMR" },
  "ST": { cc: "ST", cn: "Sao Tome and Principe", pc: 239, cc3: "STP" },
  "SA": { cc: "SA", cn: "Saudi Arabia", pc: 966, cc3: "SAU" },
  "SN": { cc: "SN", cn: "Senegal", pc: 221, cc3: "SEN" },
  "RS": { cc: "RS", cn: "Serbia", pc: 381, cc3: "SRB" },
  "SC": { cc: "SC", cn: "Seychelles", pc: 248, cc3: "SYC" },
  "SL": { cc: "SL", cn: "Sierra Leone", pc: 232, cc3: "SLE" },
  "SG": { cc: "SG", cn: "Singapore", pc: 65, cc3: "SGP" },
  "SX": { cc: "SX", cn: "Sint Maarten", pc: 599, cc3: "SXM" },
  "SK": { cc: "SK", cn: "Slovakia", pc: 421, cc3: "SVK" },
  "SI": { cc: "SI", cn: "Slovenia", pc: 386, cc3: "SVN" },
  "SB": { cc: "SB", cn: "Solomon Islands", pc: 677, cc3: "SLB" },
  "SO": { cc: "SO", cn: "Somalia", pc: 252, cc3: "SOM" },
  "ZA": { cc: "ZA", cn: "South Africa", pc: 27, cc3: "ZAF" },
  "ES": { cc: "ES", cn: "Spain", pc: 34, cc3: "ESP" },
  "LK": { cc: "LK", cn: "Sri Lanka", pc: 94, cc3: "LKA" },
  "SD": { cc: "SD", cn: "Sudan", pc: 249, cc3: "SDN" },
  "SR": { cc: "SR", cn: "Suriname", pc: 597, cc3: "SUR" },
  "SZ": { cc: "SZ", cn: "Swaziland", pc: 268, cc3: "SWZ" },
  "SE": { cc: "SE", cn: "Sweden", pc: 46, cc3: "SWE" },
  "CH": { cc: "CH", cn: "Switzerland", pc: 41, cc3: "CHE" },
  "SY": { cc: "SY", cn: "Syria", pc: 963, cc3: "SYR" },
  "TW": { cc: "TW", cn: "Taiwan", pc: 886, cc3: "TWN" },
  "TJ": { cc: "TJ", cn: "Tajikistan", pc: 992, cc3: "TJK" },
  "TZ": { cc: "TZ", cn: "Tanzania", pc: 255, cc3: "TZA" },
  "TH": { cc: "TH", cn: "Thailand", pc: 66, cc3: "THA" },
  "TL": { cc: "TL", cn: "Timor-Leste", pc: 670, cc3: "TLS" },
  "TG": { cc: "TG", cn: "Togo", pc: 228, cc3: "TGO" },
  "TK": { cc: "TK", cn: "Tokelau", pc: 690, cc3: "TKL" },
  "TO": { cc: "TO", cn: "Tonga", pc: 676, cc3: "TON" },
  "TT": { cc: "TT", cn: "Trinidad and Tobago", pc: 1868, cc3: "TTO" },
  "TN": { cc: "TN", cn: "Tunisia", pc: 216, cc3: "TUN" },
  "TR": { cc: "TR", cn: "Turkey", pc: 90, cc3: "TUR" },
  "TM": { cc: "TM", cn: "Turkmenistan", pc: 993, cc3: "TKM" },
  "TC": { cc: "TC", cn: "Turks and Caicos Islands", pc: 1649, cc3: "TCA" },
  "TV": { cc: "TV", cn: "Tuvalu", pc: 688, cc3: "TUV" },
  "UG": { cc: "UG", cn: "Uganda", pc: 256, cc3: "UGA" },
  "UA": { cc: "UA", cn: "Ukraine", pc: 380, cc3: "UKR" },
  "AE": { cc: "AE", cn: "United Arab Emirates", pc: 971, cc3: "ARE" },
  "US": { cc: "US", cn: "United States", pc: 1, cc3: "USA" },
  "UY": { cc: "UY", cn: "Uruguay", pc: 598, cc3: "URY" },
  "UZ": { cc: "UZ", cn: "Uzbekistan", pc: 998, cc3: "UZB" },
  "VU": { cc: "VU", cn: "Vanuatu", pc: 678, cc3: "VUT" },
  "VA": { cc: "VA", cn: "Vatican City", pc: 39, cc3: "VAT" },
  "VE": { cc: "VE", cn: "Venezuela", pc: 58, cc3: "VEN" },
  "VN": { cc: "VN", cn: "Vietnam", pc: 84, cc3: "VNM" },
  "VG": { cc: "VG", cn: "British Virgin Islands", pc: 1284, cc3: "VGB" },
  "VI": { cc: "VI", cn: "US Virgin Islands", pc: 1340, cc3: "VIR" },
  "EH": { cc: "EH", cn: "Western Sahara", pc: 212, cc3: "ESH" },
  "YE": { cc: "YE", cn: "Yemen", pc: 967, cc3: "YEM" },
  "ZM": { cc: "ZM", cn: "Zambia", pc: 260, cc3: "ZMB" },
  "ZW": { cc: "ZW", cn: "Zimbabwe", pc: 263, cc3: "ZWE" }
});
